<template>
  <div style="width: 60%; margin: 0 auto; margin-top: 5%">

    <h3>{{editText}}</h3>
      <br>
      <br>
      <md-datepicker v-model="donationInfo.donation_date">
        <label>Date</label>
      </md-datepicker>
      <md-field>
        <label>Location</label>
        <md-input v-model="donationInfo.local_area"></md-input>
      </md-field>

      <md-field :md-counter="false">
        <label>Notes</label>
        <md-input v-model="donationInfo.notes"></md-input>
      </md-field>
      <div style="float: right">
        <md-button @click="closeEdit">Close</md-button>
        <md-button  @click="checkAction">{{actionText}}</md-button>
      </div>

  </div>
</template>

<script>
  export default {
    name: 'Counters',
    data: () => ({
      donationInfo: {},
      edit:false,
      editText: 'Add New Donation',
      actionText: 'Add'
    }),
    beforeMount: function () {
      this.donationInfo = this.$store.state.MyDonationListStore.donationInfo.donation
      this.edit = this.$store.state.MyDonationListStore.donationInfo.edit
      this.editText =  this.edit ? 'Edit Existing Donation' : 'Add New Donation'
      this.actionText =  this.edit ? 'Update' : 'Add'
    },
    methods:{
      closeEdit(){
        this.$emit('switchPanel','MyDonationList')
      },
      checkAction(){
        console.log("checkAction");

        if (this.edit === true){
            console.log("there will be the api call");

        }
        else{
            console.log("there will be the api call for add");

        }
      },

    }
  }
</script>
